import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { formatPrice } from "../../NumberFormat";

const WinMoPopup = (props) => {
  const { status, bettype, date, gameId, limitId, period, transId, game } = props;
  const [transectionDetailData, setTransectionDetailsData] = useState([]);
  const [gameCode, setGameCode] = useState("");
  const [totalBuyers, setTotalBuyers] = useState(0);
  const [totalBuyers1, setTotalBuyers1] = useState(0);

  const featchTransectionHistoryDetail = () => {
    let reqData = {
      act: status,
      bettype: bettype,
      date: date,
      game_id: gameId,
      limitid: limitId,
      period: parseInt(period),
      trans_id: transId,
    };
    makeAjax(url.PLAYER_API.getTransaction, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }

      setTransectionDetailsData(response.data.result);
      setGameCode(response.data.game.game_code);

      const total = response.data.result.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.win_amount);
      }, 0);
      setTotalBuyers(total.toFixed(2));

      // Calculate total buyers
      const total1 = response.data.result.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.total_win);
      }, 0);
      setTotalBuyers1(total1.toFixed(2));
    });
  };

  useEffect(() => {
    featchTransectionHistoryDetail();
  }, []);

  return (
    <>
      {(gameId == 501) ?

        transectionDetailData.length === 0 ? (
          <div
            style={{
              fontSize: 13,
              color: "#ffff",
              textAlign: "center",
              paddingBottom: 20,
            }}
          >
            {props.t("data_not_found")}
          </div>
        ) : (
          <>
            <div className="poupup_detail_table">
              {transectionDetailData.map((value, index) => (
                <>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">
                      {props.t("period")}
                    </div>
                    <div className="poupup_detail_table_desc">{`${gameCode}-${value.round_id_client}`}</div>
                  </div>


                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">{props.t("Total")}</div>
                    <div className="poupup_detail_table_desc">{formatPrice(value.total_bet)}</div>
                  </div>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">{props.t("Mines")}</div>
                    <div className="poupup_detail_table_desc">{value.mine_count}</div>
                  </div>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">{props.t("Mine Tiles")}</div>
                    <div className="poupup_detail_table_desc">{value.mine_tiles?.replace(/\[|\]/g, '')}</div>
                  </div>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">{props.t("Open Tiles")}</div>
                    <div className="poupup_detail_table_desc">{value.open_tails?.replace(/\[|\]/g, '')}</div>
                  </div>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">{props.t("Total prize")}</div>
                    <div className="poupup_detail_table_desc">{formatPrice(value.total_win)}</div>
                  </div>
                </>
              ))}
              <div className="poupup_detail_table_row poupp_detail_total">
                <div className="poupup_detail_table_title">
                  {props.t("total")}
                </div>
                <div className="poupup_detail_table_desc">
                  {formatPrice(totalBuyers1)}
                </div>
              </div>
            </div>
          </>
        )
        :
        transectionDetailData.length === 0 ? (
          <div
            style={{
              fontSize: 13,
              color: "#ffff",
              textAlign: "center",
              paddingBottom: 20,
            }}
          >
            {props.t("data_not_found")}
          </div>
        ) : (
          <>
            <div className="poupup_detail_table">
              {transectionDetailData.map((value, index) => (
                <React.Fragment key={index}>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">
                      {props.t("period")}
                    </div>
                    <div className="poupup_detail_table_desc">{`${parseInt(
                      period
                    )}-${gameCode}`}</div>
                  </div>
                  {game === "Dingdong Sicbo STANDARD" ? (
                    <>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("bet")}
                        </div>
                        <div className="poupup_detail_table_desc">
                          {value.bet}
                        </div>
                      </div>

                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("bet")} 2
                        </div>
                        <div className="poupup_detail_table_desc">
                          {value.bet2}
                        </div>
                      </div>

                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("bet")} 3
                        </div>
                        <div className="poupup_detail_table_desc">
                          {value.bet3}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("bet")}
                        </div>
                        <div className="poupup_detail_table_desc">
                          {value.bet}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">
                      {props.t("amount")}
                    </div>
                    <div className="poupup_detail_table_desc">
                      {formatPrice(value.amount)}
                    </div>
                  </div>
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">
                      {props.t("discount")}
                    </div>
                    <div className="poupup_detail_table_desc">{value.disc}</div>
                  </div>
                  {value.info === "50-50" ? (
                    <>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">Kei %</div>
                        <div className="poupup_detail_table_desc">
                          {formatPrice(value.prize)}
                        </div>
                      </div>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("prize")}
                        </div>
                        <div className="poupup_detail_table_desc">-</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">Kei %</div>

                        <div className="poupup_detail_table_desc">-</div>
                      </div>
                      <div className="poupup_detail_table_row">
                        <div className="poupup_detail_table_title">
                          {props.t("prize")}
                        </div>
                        <div className="poupup_detail_table_desc">
                          {formatPrice(value.prize)}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="poupup_detail_table_row">
                    <div className="poupup_detail_table_title">
                      {props.t("total_amount")}
                    </div>
                    <div className="poupup_detail_table_desc">
                      <td>{Number(value.win_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </div>
                  </div>
                  <div className="poupup_detail_table_row popup_row_last">
                    <div className="poupup_detail_table_title">
                      {props.t("Desc")}
                    </div>
                    <div className="poupup_detail_table_desc">
                      {(game === "Dingdong Poker Dice STANDARD" || game === "Dingdong Poker Dice NEW") &&
                        (value.name === "1" || value.name === "2") ? (
                        <td>
                          {value.name} - {value.info}
                        </td>
                      ) : (
                        <td>{value.info}</td>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ))}
              <div className="poupup_detail_table_row poupp_detail_total">
                <div className="poupup_detail_table_title">
                  {props.t("total")}
                </div>
                <div className="poupup_detail_table_desc">
                  {formatPrice(totalBuyers)}
                </div>
              </div>
            </div>
          </>
        )
      }
    </>
  );
};

export default withTranslation()(WinMoPopup);
